import { render, staticRenderFns } from "./dashAcademy.vue?vue&type=template&id=33083d53&scoped=true&"
import script from "./dashAcademy.vue?vue&type=script&lang=js&"
export * from "./dashAcademy.vue?vue&type=script&lang=js&"
import style0 from "./dashAcademy.vue?vue&type=style&index=0&id=33083d53&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33083d53",
  null
  
)

export default component.exports